import { createAction } from '@reduxjs/toolkit'
import actionTypes from '../types/actionTypes'

export const setNavOpen = createAction(actionTypes.SET_NAV_OPEN)
